// disabled this rule, to have a consistent way of exporting these values. If more defaults are added, this disable is no longer needed.
// eslint-disable-next-line import/prefer-default-export
export const maxItems = -1;
